import {Box, Button} from '@mui/material';

const ButtonContainer = ({changeHandler, closeToastHandler, value}) => {
  return (
    <Box className={'BtnContainer'}>
      <Button className={'ignoreBtn'} onClick={closeToastHandler} disableRipple>
        انصراف
      </Button>
      <Button className={'confirmBtn'} onClick={() => changeHandler(value)}>
        تایید
      </Button>
    </Box>
  );
};

export default ButtonContainer;
